<template>
  <div class="echarts">
    <div class="typeBar">
      <div class="typeItem" v-for="(item, index) in typeArr" :key="index">
        <img
          v-if="index === nowIndex"
          class="itemImg"
          src="../../../assets/images/dataCenterindex/SK.png"
        />
        <div class="text" @click="changeIndex(index)">{{ item }}</div>
      </div>
    </div>
    <div id="dangyuan" :style="{width: '100%', height: '180px'}"></div>
  </div>
</template>
<script>
  import {post} from "@/api/requrestHttp";
export default {
  data() {
    return {
      nowIndex: 0,
      
      typeArr: ["党员年龄", "党员性别", "党员学历", "党员党龄"],
      dataArr: [
        [
          { name: "18-30岁", value: 50 },
          { name: "30-40岁", value: 150 },
          { name: "40-50岁", value: 250 },
          { name: "50-60岁", value: 350 },
          { name: "60-80岁", value: 450 },
          { name: "80岁以上", value: 500 }
        ],
        [
          { name: "男", value: 300 },
          { name: "女", value: 450 }
        ],
        [
          { name: "小学以下", value: 10 },
          { name: "高中", value: 20 },
          { name: "专科", value: 30 },
          { name: "本科", value: 40 },
          { name: "硕士以上", value: 50 }
        ],
        [
          { name: "1年", value: 15 },
          { name: "2年", value: 25 },
          { name: "3年", value: 35 },
          { name: "4年", value: 60 },
          { name: "5年", value: 15 }
        ]
      ],
      dataArrs:[]

    };
  },
  mounted() {
    this.getAgeGroup();
    console.log(this.dataArrs);
    this.drawLine(0);
  },
  methods: {
    drawLine(index) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("dangyuan"));
      // 绘制图表
      myChart.setOption(this.handleOption(this.dataArr[index]));
      
    },
    handleOption(data) {
      const optionData = {};

      const legendArr = data.map(item => {
        return item.name;
      });
      optionData.legend = {
        right: 10,
        top: 10,
        data: legendArr,
        orient: "vertical",
        textStyle: {
          color: "#fff"
          // rich: {
          //   a: {
          //     width: 100,
          //     color: "#000",
          //     lineHeight: 10
          //   },
          //   b: {
          // 		height: 30,
          //   }
          // }
        }
        // formatter: ["{a|{name}}", "{b|{name}}"].join("\n")
      };
      const seriesData = [
        {
          type: "pie",
          radius: ["30%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: "inner",
            formatter: "{d}%"
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "30",
              fontWeight: "bold"
            }
          },
          labelLine: {
            show: false
          },
          data: data,
          left: "-150px"
        }
      ];
      optionData.series = seriesData;
      return optionData;
    },
    //点击切换
   async changeIndex(index) {
      if (this.nowIndex === index) return;
      this.nowIndex = index;
      let data = await this.getAgeGroup();
      this.drawLine(index);
      
    },
    //拿到所有的党员数据
    getAgeGroup() {
      post("/admin/statistics/info/ageGroup", {}).then(res => {
        if (res.code == 200) {
          this.dataArrs=res.content;
          let objArr1=[];
          let objArr2=[];
          let objArr3=[];
          let objArr4=[];
          res.content.ageGroupList.forEach( item => {
            let obj = {
              name:item.name,value:item.total
            }
            objArr1.push(obj)
          })
          res.content.educationList.forEach( item => {
            let obj = {
              name:item.name,value:item.total
            }
            objArr2.push(obj)
          })
          res.content.partyAgeList.forEach( item => {
            let obj = {
              name:item.name,value:item.total
            }
            objArr3.push(obj)
          })
          res.content.sexList.forEach( item => {
            let obj = {
              name:item.name,value:item.total
            }
            objArr4.push(obj)
          })
          this.dataArr=[objArr1,objArr4,objArr2,objArr3]
          // this.modelTable = res.content
        } else {
          this.$message.error(res.message);
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
.typeBar {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.typeItem {
  width: 75px;
  height: 30px;
  position: relative;
  .itemImg {
    width: 100%;
    height: 100%;
  }
  .text {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    color: #fff;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }
}
.typeItem + .typeItem {
  margin-left: 15px;
}
</style>